const DetailSekolahEnty = {
    idSekolah: null,
    namaSekolah: null,
    noTelpSekolah: null,
    namaKepalaSekolah: null,
    noTelpKepalaSekolah: null,
    emailSekolah: null,
    alamatSekolah: null,
    namaPenanggungJawab: null,
    noTelpPenanggungJawab: null,
    kodeJenjangSekolah: null,
    kodeKategoriSekolah: null,
    jumlahGuru: null,
    tahunAjaranSnmptn: null,
    idProvinsi: null,
    idKabupatenKota: null,
    provinsi: {},
    kabupaten: {},
    paketProgram: {},
    admin: {}
}

export default DetailSekolahEnty;